import React, { useState, useEffect, useCallback } from 'react';
import {
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  Box,
  Button // CORREGIDO: Añadido Button a los imports
} from '@mui/material';
import { getTrabajos } from '../services/api';

const WeeklyView = () => {
  const [semanaTrabajos, setSemanaTrabajos] = useState({});
  const [fechaInicioSemana, setFechaInicioSemana] = useState(new Date());

  // CORREGIDO: Usar useCallback para loadDatosSemana
  const loadDatosSemana = useCallback(async () => {
    try {
      const response = await getTrabajos();
      const trabajos = response.data;
      
      // Organizar trabajos por día de la semana
      const trabajosPorDia = {};
      
      // Inicializar todos los días de la semana
      for (let i = 0; i < 7; i++) {
        const fecha = new Date(fechaInicioSemana);
        fecha.setDate(fecha.getDate() + i);
        const fechaStr = fecha.toISOString().split('T')[0];
        trabajosPorDia[fechaStr] = [];
      }

      // Asignar trabajos a sus días correspondientes
      trabajos.forEach(trabajo => {
        if (trabajosPorDia[trabajo.fecha]) {
          trabajosPorDia[trabajo.fecha].push(trabajo);
        }
      });

      setSemanaTrabajos(trabajosPorDia);
    } catch (error) {
      console.error('Error loading weekly data:', error);
    }
  }, [fechaInicioSemana]); // CORREGIDO: Añadida dependencia

  useEffect(() => {
    loadDatosSemana();
  }, [loadDatosSemana]); // CORREGIDO: Añadida loadDatosSemana como dependencia

  const getDiasSemana = () => {
    const dias = [];
    for (let i = 0; i < 7; i++) {
      const fecha = new Date(fechaInicioSemana);
      fecha.setDate(fecha.getDate() + i);
      dias.push(fecha);
    }
    return dias;
  };

  const calcularTotalDia = (trabajos) => {
    const totalMinutos = trabajos.reduce((sum, trabajo) => sum + trabajo.duracion, 0);
    return (totalMinutos / 60).toFixed(1);
  };

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Vista Semanal - {fechaInicioSemana.toLocaleDateString('es-ES')}
      </Typography>

      <Grid container spacing={2}>
        {getDiasSemana().map((fecha, index) => {
          const fechaStr = fecha.toISOString().split('T')[0];
          const trabajosDia = semanaTrabajos[fechaStr] || [];
          const totalHoras = calcularTotalDia(trabajosDia);

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" color="primary">
                    {fecha.toLocaleDateString('es-ES', { weekday: 'long' })}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {fecha.toLocaleDateString('es-ES')}
                  </Typography>
                  
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body2">
                      <strong>Total: {totalHoras}h</strong>
                    </Typography>
                    
                    {trabajosDia.map((trabajo) => (
                      <Box key={trabajo.id} sx={{ mt: 1, p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
                        <Typography variant="body2">
                          {trabajo.piso.nombre}
                        </Typography>
                        <Typography variant="caption" display="block">
                          {trabajo.duracion} min
                          {trabajo.entrada_salida && (
                            <Chip label="E/S" color="error" size="small" sx={{ ml: 1 }} />
                          )}
                        </Typography>
                      </Box>
                    ))}
                    
                    {trabajosDia.length === 0 && (
                      <Typography variant="caption" color="textSecondary">
                        Sin trabajos programados
                      </Typography>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Button 
          variant="outlined"
          onClick={() => {
            const nuevaFecha = new Date(fechaInicioSemana);
            nuevaFecha.setDate(nuevaFecha.getDate() - 7);
            setFechaInicioSemana(nuevaFecha);
          }}
        >
          Semana Anterior
        </Button>
        
        <Button 
          variant="outlined"
          onClick={() => setFechaInicioSemana(new Date())}
        >
          Esta Semana
        </Button>
        
        <Button 
          variant="outlined"
          onClick={() => {
            const nuevaFecha = new Date(fechaInicioSemana);
            nuevaFecha.setDate(nuevaFecha.getDate() + 7);
            setFechaInicioSemana(nuevaFecha);
          }}
        >
          Semana Siguiente
        </Button>
      </Box>
    </Paper>
  );
};

export default WeeklyView;